import React from 'react';
import { useTranslation } from 'react-i18next';
import chairmanImage from '../../assets/images/Chairman-official-image.jpg';
import styles from './ChairmanSpeech.module.css';

const ChairmanSpeech = () => {
  const { t } = useTranslation();

  return (
    <section className={styles.chairmanSection}>
      <div className={styles.container}>
        {/* Section Header */}
        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>{t('chairman.title')}</h2>
          <div className={styles.titleUnderline}></div>
        </div>

        {/* Content */}
        <div className={styles.content}>
          {/* Chairman Image */}
          <div className={styles.imageContainer}>
            <div className={styles.imageWrapper}>
              <img 
                src={chairmanImage} 
                alt={t('chairman.imageAlt')}
                className={styles.chairmanImage}
              />
              <div className={styles.imageFrame}></div>
            </div>
            <div className={styles.chairmanInfo}>
              <h3 className={styles.chairmanName}>{t('chairman.name')}</h3>
              <p className={styles.chairmanTitle}>{t('chairman.position')}</p>
            </div>
          </div>

          {/* Speech Text */}
          <div className={styles.speechContainer}>
            <div className={styles.quoteIcon}>
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"/>
              </svg>
            </div>
            <p className={styles.speechText}>
              {t('chairman.speech')}
            </p>
            <div className={styles.signature}>
              <div className={styles.signatureLine}></div>
              <p className={styles.signatureName}>{t('chairman.name')}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ChairmanSpeech;

